import Vue from 'vue';
import 'babel-polyfill'
import Vuetify from "./plugins/vuetify";
import store from './store'
import App from './App.vue';
import router from "./router";
import moment from "moment";
import i18n from './locale/i18n';
import "./plugins/matomo";
import "./plugins/autocomplete";
import UserService from "./api/UserService";
import PerfectScrollbar from 'vue2-perfect-scrollbar'
import 'vue2-perfect-scrollbar/dist/vue2-perfect-scrollbar.css'
import 'vue-cookie-accept-decline/dist/vue-cookie-accept-decline.css';
import VueCookieAcceptDecline from 'vue-cookie-accept-decline';
import './registerServiceWorker'

Vue.config.productionTip = false;

moment.locale(window.navigator.language);

Vue.use(PerfectScrollbar);
Vue.component('vue-cookie-accept-decline', VueCookieAcceptDecline)

new Vue({
    router,
    store: store,
    vuetify: Vuetify,
    i18n,
    render: h => h(App)
}).$mount("#app");